import apiConfig from "../../config/apiConfig";
import apiConfigWthFormData from "../../config/apiConfigWthFormData";
import { objToQueryString, showSuccessToasts } from "../../services/helpers/Helper";
import { FAQ_TYPE, END_POINT } from "../constants";
import { setError } from "./errorAction";
import { hideLoading, showLoading } from "./loadingAction";

export const fetchFaqs = () =>
   async (dispatch, getState) => {
      const { page } = getState();
      const params = {
         fb_page_id: page.social_id,
      }
      const qs = objToQueryString(params);
      const endPoint = `${END_POINT.ICE_BREAKER}?${qs}`;
      dispatch(showLoading());
      apiConfig.get(endPoint).then((response) => {
         dispatch({
            type: FAQ_TYPE.FETCHS,
            payload: response.data
         })
      }).catch((error) => {
         dispatch(setError(error.message));
      }).finally(() => {
         dispatch(hideLoading());
      });
   };

export const fetchFaq = (id) =>
   async (dispatch, getState) => {
      const { page } = getState();
      const params = {
         fb_page_id: page.social_id,
         item_id: id
      }
      const qs = objToQueryString(params);
      const endPoint = `${END_POINT.ICE_BREAKER_ITEMS}?${qs}`;
      dispatch(showLoading());
      apiConfig.get(endPoint).then((response) => {
         dispatch({
            type: FAQ_TYPE.FETCH,
            payload: response.data
         });
      }).catch((error) => {
         dispatch(setError(error.message));
      }).finally(() => {
         dispatch(hideLoading());
      });
   };

export const addFaq = (faq) =>
   async (dispatch) => {
      dispatch({
         type: FAQ_TYPE.ADD,
         payload: faq
      })
   };

export const createFaq = (string) =>
   async (dispatch, getState) => {
      const { page } = getState();
      const params = {
         is_actived: 1,
         sort: 0,
         name: string,
         answer: "Nội dung câu trả lời"
      }
      const qs = objToQueryString({
         fb_page_id: page.social_id
      });
      const endPoint = `${END_POINT.ICE_BREAKER_ITEMS}?${qs}`;
      dispatch(showLoading());
      apiConfig.post(endPoint, params).then(() => {
         dispatch(fetchFaqs());
         showSuccessToasts('Tạo câu hỏi thành công');
      }).catch((error) => {
         dispatch(setError(error.message));
      }).finally(() => {
         dispatch(hideLoading());
      });
   };

export const deleteFaq = (id, callbackSuccess) =>
   async (dispatch, getState) => {
      const { page } = getState();
      const params = {
         fb_page_id: page.social_id,
         item_id: id
      }
      const qs = objToQueryString(params);
      const endPoint = `${END_POINT.ICE_BREAKER_ITEMS}?${qs}`;
      dispatch(showLoading());
      apiConfigWthFormData.delete(endPoint, params).then(() => {
         showSuccessToasts('Xóa câu hỏi thành công');
         dispatch({
            type: FAQ_TYPE.DELETE,
            payload: id
         });
         if (callbackSuccess) callbackSuccess()
      }).catch((error) => {
         dispatch(setError(error.message));
      }).finally(() => {
         dispatch(hideLoading());
      });
   };

export const deletefaqNotActive = () =>
   async (dispatch) => {
      dispatch({
         type: FAQ_TYPE.DELETE_NOT_ACTIVE
      })
   };

export const updateActiveFaq = (boolean) =>
   async (dispatch, getState) => {
      const { page } = getState();
      const params = {
         fb_page_id: page.social_id,
         is_active: boolean
      }
      const endPoint = END_POINT.ACTIVE_ICEBREAKERS;
      dispatch(showLoading());
      apiConfigWthFormData.post(endPoint, params).then((response) => {
         dispatch({
            type: FAQ_TYPE.UPDATE_ACTIVE,
            payload: boolean
         });
         showSuccessToasts('Cập nhật trạng thái thành công');
      }).catch((error) => {
         dispatch(setError(error.message));
      }).finally(() => {
         dispatch(hideLoading());
      });


   };

export const onChange = (answer) =>
   async (dispatch) => {
      dispatch({
         type: FAQ_TYPE.ON_CHANGE,
         payload: answer
      })
   };

export const hanldeUpdateName = (obj, name) =>
   async (dispatch) => {
      const params = {
         ...obj,
         name
      }
      dispatch(hanldeUpdate(params, () => {
         dispatch({
            type: FAQ_TYPE.UPDATE_NAME,
            payload: params
         });
         showSuccessToasts('Cập nhật thành công');
      }));
   };

export const hanldeUpdate = (params, callbackSuccess) =>
   async (dispatch, getState) => {
      const { page } = getState();
      const qs = objToQueryString({
         fb_page_id: page.social_id
      });
      const endPoint = `${END_POINT.ICE_BREAKER_ITEMS}?${qs}`;
      dispatch(showLoading());
      apiConfig.post(endPoint, params).then((response) => {
         if (callbackSuccess) {
            callbackSuccess(response)
         }
      }).catch((error) => {
         dispatch(setError(error.message));
      }).finally(() => {
         dispatch(hideLoading());
      });
   };

export const handleUpdateFaq = (callbackSuccess) =>
   async (dispatch, getState) => {
      const { faq: faqAll } = getState();
      const { faq } = faqAll;
      dispatch(hanldeUpdate(faq, (response) => {
         showSuccessToasts('Cập nhật thành công');
         dispatch(fetchFaq(faq.id));
         if (callbackSuccess) {
            callbackSuccess(response)
         }
      }));
   }   